<template>
  <div class="paper-rejoin-arrange-add" v-loading="loading" element-loading-text="数据加载中，请稍等...">
    <div class="cont" v-if="allTeacherList.length">
      <el-form size="mini" label-width="100px" label-suffix="：">
        <el-form-item label="答辩组长" required>
          <el-select v-model="form.leader" placeholder="请选择答辩组长">
            <el-option v-for="teacher in leaderList" :key="teacher.id" :label="teacher.name" :value="teacher.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="答辩组员" required>
          <el-select v-model="form.teacherIds" filterable multiple placeholder="请选择答辩组员">
            <el-option v-for="teacher in teacherList" :key="teacher.id" :label="teacher.name" :value="teacher.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="答辩组名">
          <el-input v-model="form.rejoinName" placeholder="请输入答辩组名"></el-input>
        </el-form-item>
        <el-form-item label="答辩时间">
          <el-date-picker v-model="form.rejoinDate" type="datetime" value-format="yyyy-MM-dd HH:mm" placeholder="请选择答辩时间"></el-date-picker>
        </el-form-item>
        <el-form-item label="答辩地点">
          <el-input v-model="form.rejoinAddress" placeholder="请输入答辩地点"></el-input>
        </el-form-item>
        <el-form-item label="答辩须知">
          <el-input v-model="form.rejoinNote" placeholder="请输入答辩须知" type="textarea" :rows="3"></el-input>
        </el-form-item>
      </el-form>
      <div class="footer">
        <el-button @click="handleCancel">取消</el-button>
        <el-button type="primary" :loading="committing" @click="handleSubmit">{{ committing ? '提交中...' : '提交' }}</el-button>
      </div>
    </div>
    <Hint v-else v-show="errorMsg">{{ errorMsg }}</Hint>
  </div>
</template>

<script>
import Hint from '../../../../../../../elements/Hint.vue'
export default {
  name: 'PaperRejoinArrangeAdd',
  components: {
    Hint
  },
  props: {
    paperBatchId: {
      type: String,
      required: true
    },
    visible: {
      type: Boolean,
      required: true
    },
    extraId: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      committing: false,
      errorMsg: '',
      allTeacherList: [],
      form: {
        leader: '',
        teacherIds: [],
        rejoinName: '',
        rejoinDate: '',
        rejoinAddress: '',
        rejoinNote: ''
      }
    }
  },
  computed: {
    leaderList () {
      if (this.allTeacherList.length) {
        return this.allTeacherList.filter(teacher => !this.form.teacherIds.includes(teacher.id))
      }
      return []
    },
    teacherList () {
      if (this.allTeacherList.length) {
        return this.allTeacherList.filter(teacher => this.form.leader !== teacher.id)
      }
      return []
    }
  },
  methods: {
    handleCancel () {
      this.$emit('hidePopover')
    },
    loadData () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/paper/rejoin/arrange/queryTeacher',
        method: 'post',
        data: this.$qs.stringify({
          paperBatchId: this.paperBatchId
        })
      }).then(response => {
        if (response.data && response.data.errorCode === 0) {
          this.allTeacherList = response.data.teacherList || []
          if (!this.allTeacherList.length) {
            this.errorMsg = '暂无答辩教师'
          }
        } else {
          this.errorMsg = response.data.message || '获取答辩教师失败'
        }
      }, () => {
        this.errorMsg = '获取答辩教师失败'
      }).finally(() => {
        this.loading = false
      })
    },
    handleSubmit () {
      const form = this.form
      if (!form.leader) {
        this.$message.warning('请选择答辩组长')
        return
      }
      if (!form.teacherIds.length) {
        this.$message.warning('请选择答辩组员')
        return
      }
      this.committing = true
      this.$ajax({
        url: '/workspace/manager/paper/rejoin/arrange/saveArrange',
        method: 'post',
        data: this.$qs.stringify(this.$extend({
          paperBatchId: this.paperBatchId,
          postIds: this.extraId
        }, form), {arrayFormat: 'repeat'})
      }).then(response => {
        if (response.data && response.data.errorCode === 0) {
          this.$message.success('提交成功')
          this.$emit('hidePopoverAndRefresh')
        } else {
          this.$message.error(response.data.message || '提交失败')
        }
      }, () => {
        this.$message.error('提交失败')
      }).finally(() => {
        this.committing = false
      })
    }
  },
  watch: {
    visible: {
      handler (val) {
        if (val) {
          this.loadData()
        } else {
          this.form = {
            leader: '',
            teacherIds: [],
            rejoinName: '',
            rejoinDate: '',
            rejoinAddress: '',
            rejoinNote: ''
          }
        }
      },
      immediate: true
    }
  }
}
</script>

<style scoped lang="scss">
.paper-rejoin-arrange-add{
  height: 370px;
  & > .cont{
    height: 100%;
    display: flex;
    flex-direction: column;
    ::v-deep  .el-form{
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 20px;
      overflow-y: auto;
      & > .el-form-item{
        margin-bottom: 10px;
        &:last-child{
          margin-bottom: 0;
        }
        & > .el-form-item__label{
          font-size: 12px;
        }
        & > .el-form-item__content{
          & > .el-select,
          & > .el-input,
          & > .el-textarea{
            width: 260px;
          }
        }
      }
    }
    & > .footer{
      padding: 10px 0;
      text-align: center;
      background-color: #fff;
    }
  }
}
</style>
